import { MILLION } from 'constants/dataSets';
import {
  ADDRESS_BUILDING,
  ADDRESS_CITY,
  ADDRESS_COORDINATES,
  ADDRESS_COUNTRY,
  ADDRESS_POST_CODE,
  ADDRESS_STATE,
  ADDRESS_STREET,
  BUSINESS_UNIT_TYPE,
  CODE,
  DATE_CLOSED,
  DATE_OPENED,
  EQUITY_SHAREHOLDING,
  EU_TAXONOMY_CODE,
  FINANCIAL_CONTROL,
  NACE_CODE,
  NACE_SECTION,
  NAME,
  OWNERSHIP,
  PRIORITY_RATING,
  PROFIT_CENTER_LINKS,
  UNIQUE_IDENTIFIER,
  VALUE_CHAIN_LIST,
  VALUE_CHAIN_SECTION,
} from 'constants/formFields';
import { DATA_SETS_DATE_FORMAT, DATE_FORMAT_ISO } from 'constants/general';
import dayjs from 'dayjs';

import type IProfitCenterLink from 'store/slices/dataSets/interfaces/IProfitCenterLink';
import type { IGetRequestDataForCustomer } from './interfaces/IGetRequestDataForCustomer';

function getRequestDataForCustomerUpdate({
  values, recordId, companyCurrency, valueChainForm, includeUniqueIdentifier,
}: IGetRequestDataForCustomer) {
  const getProfitCenterLinks = (
    profitCenterLinks: IProfitCenterLink[],
  ) => profitCenterLinks.map((profitCenterLink) => ({
    profitCenterId: profitCenterLink.profitCenterId || null,
    startDate: dayjs(profitCenterLink.startDate, DATA_SETS_DATE_FORMAT).format(DATE_FORMAT_ISO) || null,
    endDate: dayjs(profitCenterLink.endDate, DATA_SETS_DATE_FORMAT).format(DATE_FORMAT_ISO) || null,
    totalCost: {
      amount: profitCenterLink.totalCost ? Number(profitCenterLink.totalCost) * MILLION : null,
      currency: companyCurrency || null,
    },
    percentOfTotalCost: profitCenterLink.percentOfTotalCost || 0,
  }));

  return {
    [PROFIT_CENTER_LINKS]: getProfitCenterLinks(values?.[PROFIT_CENTER_LINKS]),
    [NAME]: values?.[NAME] || null,
    [CODE]: values?.[CODE] || null,
    [OWNERSHIP]: values[OWNERSHIP]?.value || null,
    [EQUITY_SHAREHOLDING]: values?.[EQUITY_SHAREHOLDING] ? Number(values?.[EQUITY_SHAREHOLDING]) : null,
    ...(!recordId || valueChainForm !== true ? {
      [VALUE_CHAIN_SECTION]: `${values?.[VALUE_CHAIN_LIST]?.value}. ${values?.[VALUE_CHAIN_SECTION]?.value}` || null,
    } : {}),
    [FINANCIAL_CONTROL]: values?.[FINANCIAL_CONTROL] ? Number(values?.[FINANCIAL_CONTROL]) : null,
    [EU_TAXONOMY_CODE]: values?.[EU_TAXONOMY_CODE] || null,
    [BUSINESS_UNIT_TYPE]: values?.[BUSINESS_UNIT_TYPE]?.value || null,
    [DATE_OPENED]: values?.[DATE_OPENED] ? dayjs(values?.[DATE_OPENED], DATA_SETS_DATE_FORMAT).format(DATE_FORMAT_ISO)
      : null,
    [DATE_CLOSED]: values?.[DATE_CLOSED] ? dayjs(values?.[DATE_CLOSED], DATA_SETS_DATE_FORMAT).format(DATE_FORMAT_ISO)
      : null,
    [PRIORITY_RATING]: values?.[PRIORITY_RATING]?.value ? Number(values?.[PRIORITY_RATING]?.value) : null,
    [NACE_SECTION]: values?.[NACE_SECTION]?.value || null,
    [NACE_CODE]: values[NACE_CODE]?.value || null,
    [ADDRESS_COUNTRY]: values?.[ADDRESS_COUNTRY]?.value || null,
    [ADDRESS_STATE]: values?.[ADDRESS_STATE]?.label || null,
    [ADDRESS_POST_CODE]: values?.[ADDRESS_POST_CODE] || null,
    [ADDRESS_CITY]: values?.[ADDRESS_CITY]?.label || null,
    [ADDRESS_STREET]: values?.[ADDRESS_STREET] || null,
    [ADDRESS_BUILDING]: values?.[ADDRESS_BUILDING] || null,
    [ADDRESS_COORDINATES]: values?.[ADDRESS_COORDINATES] || null,
    ...((!recordId || includeUniqueIdentifier) && { [UNIQUE_IDENTIFIER]: values?.[UNIQUE_IDENTIFIER] || null }),
    ...(recordId && { id: Number(recordId) }),
  };
}

export default getRequestDataForCustomerUpdate;
